import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const On = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="on icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 22 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 0C9.89543 0 9 0.895431 9 2V10C9 11.1046 9.89543 12 11 12C12.1046 12 13 11.1046 13 10V2C13 0.895431 12.1046 0 11 0ZM6.33383 7.78198C7.15688 7.04532 7.22692 5.78093 6.49027 4.95788C5.75362 4.13483 4.48923 4.06478 3.66617 4.80144C1.41895 6.81275 0 9.742 0 13C0 19.0752 4.92487 24 11 24C17.0751 24 22 19.0752 22 13C22 9.742 20.581 6.81275 18.3338 4.80144C17.5108 4.06478 16.2464 4.13483 15.5097 4.95788C14.7731 5.78093 14.8431 7.04532 15.6662 7.78198C17.1014 9.06658 18 10.927 18 13C18 16.866 14.866 20 11 20C7.13401 20 4 16.866 4 13C4 10.927 4.89855 9.06658 6.33383 7.78198Z"
    />
  </svg>
)
